function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#000",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.566 15.775a5.209 5.209 0 1010.417 0 5.209 5.209 0 00-10.417 0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.51 15.775h-1.736v-2.604M8.83 16.642H1.885a.868.868 0 01-.868-.868V3.622c0-.48.389-.869.868-.869H17.51c.48 0 .868.39.868.869v5.642M5.358 1.018v4.341m8.68-4.341v4.341M1.017 7.095h17.361"
}));

function SvgScheduleBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22
  }, props), _ref);
}

export default SvgScheduleBlack;